import { create } from 'zustand'

// Registr známých neúplných řad, které se PRÁVĚ nedotahují — uživatel odmítl
// („Nedotahovat"), režim je 'off', nebo běží pauza cache pokusů (fill-attempt-cache.md).
// Plní ho useToFill místo aby to_fill položky zahodilo.
// Čte ho IncompleteDataBadge (pravý dolní roh) — nabídne „Dotáhnout" i dodatečně.
//
// Klíčováno per-obrazovka (JSON(queryKey) / screenKey). Badge agreguje VŠECHNY
// obrazovky — po odchodu ze stránky se její klíč smaže (remove() z Effect 2 cleanup),
// takže v praxi drží jen řady aktuální stránky.

export const useIncompleteDataStore = create((set) => ({
  // { [screenKey]: [{ key: attemptKey, item, retryCtx }] }
  byScreen: {},

  // Nastaví seznam neúplných řad pro obrazovku. Prázdný seznam → klíč se smaže.
  // Idempotentní — když se obsah nezměnil, stav se nemění (žádný zbytečný render).
  set: (screenKey, list) => set((s) => {
    const cur = s.byScreen[screenKey]
    if (!list || list.length === 0) {
      if (!cur) return s
      const next = { ...s.byScreen }
      delete next[screenKey]
      return { byScreen: next }
    }
    if (cur && sameKeys(cur, list)) return s
    return { byScreen: { ...s.byScreen, [screenKey]: list } }
  }),

  // Smaže obrazovku (odchod ze stránky) nebo jednu řadu (po dotažení).
  remove: (screenKey, key) => set((s) => {
    const cur = s.byScreen[screenKey]
    if (!cur) return s
    const next = { ...s.byScreen }
    if (key == null) {
      delete next[screenKey]
    } else {
      const list = cur.filter((e) => e.key !== key)
      if (list.length === cur.length) return s
      if (list.length === 0) delete next[screenKey]
      else next[screenKey] = list
    }
    return { byScreen: next }
  }),

  clear: () => set({ byScreen: {} }),
}))

const sameKeys = (a, b) =>
  a.length === b.length && a.every((e, i) => e.key === b[i].key)
